<template>
  <div class="comment-item">
    <header>
      <div class="mode">{{ getTypeString(comment.InteractionType) }}</div>
      <!-- new or follow up. follow up if result is call-again or email-again-->
      <!-- <div class="type" :class="{ new: comment.type == 'New' }">
        {{ comment.type }}
      </div> -->
    </header>
    <div class="date">
      {{ moment(comment.ActivityDate).format("MM/DD/YYYY") }} |
      {{ comment.ContactLastName }}, {{ comment.ContactFirstName }} |
      Updated By: {{ comment.ChangesetModifiedBy }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { MiniCrmInteraction } from "@/Domain/MiniCrmInteraction";
import {
  EnumMiniCrmInteractionType,
  InteractionTypes,
} from "@/Domain/EnumMiniCrmInteractionType";
import moment from "moment";

defineProps<{
  comment: MiniCrmInteraction;
}>();

const getTypeString = (type: EnumMiniCrmInteractionType) => {
  return InteractionTypes.find((x) => x.value === type)?.text;
};
</script>

<style scoped lang="scss">
.comment-item {
  background: white;
  border-radius: 4px;
  padding: 16px 14px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.04);
  margin-right: 20px;
  position: relative;
  font-size: 14px;
  margin-bottom: 12px;
  cursor: pointer;

  > header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  &:hover {
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
  }

  .type {
    border-radius: 20px;
    background: #fff1eb;
    color: #ff8142;
    padding: 5px 7px;
    line-height: 1;
    font-size: 13px;

    &.new {
      background: #f3ffe9;
      color: #067306;
    }
  }

  .result {
    color: #4e535a;
    font-size: 13px;
    margin-bottom: 5px;
  }

  .date {
    margin-bottom: 5px;
  }

  .date,
  .comment {
    color: #9fa4aa;
  }

  &:before {
    content: "";
    position: absolute;
    left: -18px;
    top: -4px;
    border-radius: 50%;
    height: 14px;
    width: 14px;
    background: #eeeff0;
  }

  &:after {
    content: "";
    position: absolute;
    left: -14px;
    top: 0px;
    border-radius: 50%;
    height: 6px;
    width: 6px;
    background: #4e545a;
  }
}
</style>
